import { current } from "@reduxjs/toolkit";
import axios from "axios"
import { useEffect, useState } from "react";

export default function TransactionsModule({ baseUrl, client, currentUser }: { baseUrl: string, client: any, currentUser: any }) {
    const [loadingTransactions, setLoadingTransactions] = useState(true);
    const [transactions, setTransactions] = useState<any>([{}]);
    const getTransactions = async () => {

        try {
            const response = await axios.get(baseUrl + '/getLatestTransactions', { params: { client_uid: client?.uid, filter: 'today', token: currentUser?.token } });

            if (response.data.status === "OK") {
                setTransactions(response.data.data);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoadingTransactions(false);
        }
    }
    const handleCSVExportClick = () => {
        if (!transactions || transactions.length === 0) return;

        const headers = ['Kunde', 'E-post', 'Beløp', 'Valuta', 'Kanal', 'Tidspunkt'];

        const rows = transactions.map((t: any) => [
            t.customer?.name ?? '',
            t.customer?.email ?? '',
            t.charge_price ?? '',
            client?.currency ?? '',
            t.type ?? '',
            t.created_at ?? t.createdAt ?? '',
        ]);

        const escapeCell = (cell: any) => {
            const s = String(cell ?? '');
            if (s.includes('"') || s.includes(',') || s.includes('\n')) {
                return `"${s.replace(/"/g, '""')}"`;
            }
            return s;
        };

        const csv = [headers, ...rows].map(row => row.map(escapeCell).join(',')).join('\r\n');

        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        const timestamp = new Date().toISOString().slice(0, 19).replace(/[:T]/g, '-');
        a.download = `transactions_${timestamp}.csv`;
        document.body.appendChild(a);
        a.click();
        setTimeout(() => {
            URL.revokeObjectURL(url);
            a.remove();
        }, 100);
    }

    useEffect(() => {
        if (!client) return;
        getTransactions();
    }, [client?.uid, baseUrl, currentUser])
    
    return (
        <div className="bg-white rounded-2xl border border-slate-100 p-6 shadow-sm">
            <div className="flex items-center justify-between mb-4">
                <h2 className="text-sm font-semibold">Siste transaksjoner</h2>
                <button onClick={() => handleCSVExportClick()} className="text-xs text-indigo-600 hover:underline">Eksporter</button>
            </div>

            <div className="grid grid-cols-3 text-[11px] text-slate-500 mb-2">
                <span>Kunde</span>
                <span>Beløp</span>
                <span className="text-right">Kanal</span>
            </div>

            {loadingTransactions ? (
                <div className="flex items-center justify-center h-64 w-full">
                    <div className="flex flex-col items-center">
                        <div className="w-12 h-12 border-4 border-purple-400 border-t-transparent rounded-full animate-spin"></div>
                        <p className="mt-3 text-gray-600 animate-pulse">Laster...</p>
                    </div>
                </div>
            ) : (
                <ul className="space-y-3 text-sm h-[170px] overflow-y-auto">
                    {transactions.length === 0 && (
                        <li className="flex items-center justify-between py-1 border-b border-slate-100">
                            <span className="text-medium">Ingen siste transaksjon</span>
                        </li>
                    )}
                    {transactions.map((t: any, i: number) => (
                        <li key={i} className="flex items-center justify-between py-1 border-b border-slate-100">
                            <span className="text-sm">{t.customer?.name}</span>
                            <span className="font-medium">{t.charge_price + " " + client?.currency}</span>
                            <span className="text-[11px] bg-slate-100 text-slate-600 px-2 py-0.5 rounded-full">{t.type}</span>
                        </li>
                    ))}
                </ul>

            )}

        </div>
    )
}